<template>
  <div id="universities" v-loading="loading">
    <!-- 面包导航 -->
    <el-breadcrumb
      separator="/"
      style="padding-left: 10px; padding-bottom: 10px; font-size: 12px"
    >
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学校管理</el-breadcrumb-item>
      <el-breadcrumb-item>学校列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片主体 -->
    <el-card class="box-card">
      <div class="block">
        <!-- 搜索条件区 -->
        <el-form
          :inline="true"
          :model="searchForm"
          class="search-form"
          size="mini"
        >
          <el-form-item label="学校名称">
            <el-input
              v-model="searchForm.univName"
              placeholder="请输入学校名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="所在省份">
            <el-input
              v-model="searchForm.provName"
              placeholder="请输入省份"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="所在城市">
            <el-input
              v-model="searchForm.univLocation"
              placeholder="请输入城市"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="学校类型">
            <el-input
              v-model="searchForm.univTypeName"
              placeholder="如：综合类"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询</el-button
            >
            <el-button icon="el-icon-refresh" @click="resetSearch"
              >重置</el-button
            >
          </el-form-item>
        </el-form>

        <!-- 功能按钮区 -->
        <el-row :gutter="20" style="margin-bottom: 15px">
          <el-col>
            <el-button
              v-hasPermission="'university:add'"
              type="primary"
              icon="el-icon-plus"
              @click="openAddDialog"
              >新增学校</el-button
            >
            <el-button
              v-hasPermission="'university:sync'"
              type="success"
              icon="el-icon-sync"
              style="margin-left: 10px"
              @click="syncToRedis"
              >同步Redis</el-button
            >
            <el-button
              v-hasPermission="'university:export'"
              type="warning"
              icon="el-icon-download"
              style="margin-left: 10px"
              @click="exportExcel"
              >导出Excel</el-button
            >
          </el-col>
        </el-row>

        <!-- 学校列表表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          row-key="univId"
          highlight-current-row
        >
          <el-table-column
            prop="univId"
            label="学校ID"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="univName"
            label="学校名称"
            min-width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="competentDepart"
            label="主管部门"
            min-width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="provName"
            label="所在省份"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="univLocation"
            label="所在城市"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="univTypeName"
            label="学校类型"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column label="办学层次" width="180" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.is985" type="danger" size="mini"
                >985</el-tag
              >
              <el-tag v-if="scope.row.is211" type="warning" size="mini"
                >211</el-tag
              >
              <el-tag v-if="scope.row.isFirstClass" type="success" size="mini"
                >双一流</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                v-hasPermission="'university:edit'"
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="openEditDialog(scope.row)"
                >编辑</el-button
              >
              <el-button
                v-hasPermission="'university:delete'"
                size="mini"
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click="handleDelete(scope.row.univId)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页控件 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total,
          sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 15px; text-align: right"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新增学校弹窗 -->
    <el-dialog
      :title="addTitle"
      :visible.sync="addDialogVisible"
      @close="resetAddForm"
      width="60%"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        label-width="120px"
        :rules="formRules"
        size="mini"
      >
        <el-form-item label="学校名称" prop="univName">
          <el-input
            v-model="addForm.univName"
            placeholder="请输入学校名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="主管部门" prop="competentDepart">
          <el-input
            v-model="addForm.competentDepart"
            placeholder="请输入主管部门"
          ></el-input>
        </el-form-item>
        <el-form-item label="学校地址" prop="univAddress">
          <el-input
            v-model="addForm.univAddress"
            placeholder="请输入学校地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在省份" prop="provName">
          <el-input
            v-model="addForm.provName"
            placeholder="请输入所在省份"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在城市" prop="univLocation">
          <el-input
            v-model="addForm.univLocation"
            placeholder="请输入所在城市"
          ></el-input>
        </el-form-item>
        <el-form-item label="学校类型" prop="univTypeName">
          <el-input
            v-model="addForm.univTypeName"
            placeholder="如：综合类、理工类"
          ></el-input>
        </el-form-item>
        <el-form-item label="办学层次">
          <el-checkbox-group v-model="addForm.levelFlags">
            <el-checkbox label="is985" border>985</el-checkbox>
            <el-checkbox label="is211" border>211</el-checkbox>
            <el-checkbox label="isFirstClass" border>双一流</el-checkbox>
            <el-checkbox label="isFirstLevel" border>本科一批</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="办学类型">
          <el-checkbox-group v-model="addForm.educationTypes">
            <el-checkbox label="hasRegular" border>本科</el-checkbox>
            <el-checkbox label="hasJunior" border>专科</el-checkbox>
            <el-checkbox label="hasMaster" border>硕士点</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="logo地址" prop="logoCloud">
          <el-input
            v-model="addForm.logoCloud"
            placeholder="请输入logo云存储地址"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAddForm" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑学校弹窗 -->
    <el-dialog
      :title="editTitle"
      :visible.sync="editDialogVisible"
      @close="resetEditForm"
      width="60%"
    >
      <el-form
        ref="editFormRef"
        :model="editForm"
        label-width="120px"
        :rules="formRules"
        size="mini"
      >
        <el-form-item label="学校ID" prop="univId">
          <el-input v-model="editForm.univId" disabled></el-input>
        </el-form-item>
        <el-form-item label="学校名称" prop="univName">
          <el-input
            v-model="editForm.univName"
            placeholder="请输入学校名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="主管部门" prop="competentDepart">
          <el-input
            v-model="editForm.competentDepart"
            placeholder="请输入主管部门"
          ></el-input>
        </el-form-item>
        <el-form-item label="学校地址" prop="univAddress">
          <el-input
            v-model="editForm.univAddress"
            placeholder="请输入学校地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在省份" prop="provName">
          <el-input
            v-model="editForm.provName"
            placeholder="请输入所在省份"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在城市" prop="univLocation">
          <el-input
            v-model="editForm.univLocation"
            placeholder="请输入所在城市"
          ></el-input>
        </el-form-item>
        <el-form-item label="学校类型" prop="univTypeName">
          <el-input
            v-model="editForm.univTypeName"
            placeholder="如：综合类、理工类"
          ></el-input>
        </el-form-item>
        <el-form-item label="办学层次">
          <el-checkbox-group v-model="editForm.levelFlags">
            <el-checkbox label="is985" border>985</el-checkbox>
            <el-checkbox label="is211" border>211</el-checkbox>
            <el-checkbox label="isFirstClass" border>双一流</el-checkbox>
            <el-checkbox label="isFirstLevel" border>本科一批</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="办学类型">
          <el-checkbox-group v-model="editForm.educationTypes">
            <el-checkbox label="hasRegular" border>本科</el-checkbox>
            <el-checkbox label="hasJunior" border>专科</el-checkbox>
            <el-checkbox label="hasMaster" border>硕士点</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="logo地址" prop="logoCloud">
          <el-input
            v-model="editForm.logoCloud"
            placeholder="请输入logo云存储地址"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditForm" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Universities",
  data() {
    return {
      // 加载状态
      loading: false,
      btnLoading: false,
      // 表格数据
      tableData: [],
      total: 0, // 总条数
      pageNum: 1, // 当前页码（核心变量，与分页控件绑定）
      pageSize: 10, // 每页条数
      // 查询条件
      searchForm: {
        univName: "", // 学校名称
        provName: "", // 所在省份
        univLocation: "", // 所在城市
        univTypeName: "", // 学校类型
        is985: null,
        is211: null,
        isFirstClass: null,
      },
      // 弹窗控制
      addDialogVisible: false,
      editDialogVisible: false,
      addTitle: "新增学校",
      editTitle: "编辑学校",
      // 表单数据
      addForm: {
        univName: "",
        competentDepart: "",
        univAddress: "",
        provName: "",
        univLocation: "",
        univTypeName: "",
        levelFlags: [], // 关键：初始化为空数组（响应式）
        educationTypes: [], // 关键：初始化为空数组（响应式）
        logoCloud: "",
        is985: false,
        is211: false,
        isFirstClass: false,
        isFirstLevel: false,
        hasRegular: false,
        hasJunior: false,
        hasMaster: false,
      },
      editForm: {
        univId: "",
        univName: "",
        competentDepart: "",
        univAddress: "",
        provName: "",
        univLocation: "",
        univTypeName: "",
        levelFlags: [], // 关键：初始化为空数组（响应式）
        educationTypes: [], // 关键：初始化为空数组（响应式）
        logoCloud: "",
        is985: false,
        is211: false,
        isFirstClass: false,
        isFirstLevel: false,
        hasRegular: false,
        hasJunior: false,
        hasMaster: false,
      },
      // 表单验证规则
      formRules: {
        univName: [
          { required: true, message: "学校名称不能为空", trigger: "blur" },
          { min: 2, max: 100, message: "长度在2-100个字符", trigger: "blur" },
        ],
        competentDepart: [
          { required: true, message: "主管部门不能为空", trigger: "blur" },
        ],
        provName: [
          { required: true, message: "所在省份不能为空", trigger: "blur" },
        ],
        univLocation: [
          { required: true, message: "所在城市不能为空", trigger: "blur" },
        ],
        univTypeName: [
          { required: true, message: "学校类型不能为空", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.loadUniversityList(); // 初始加载第一页
  },
  methods: {
    /**
     * 加载学校列表（分页+条件查询）
     */
    async loadUniversityList() {
      this.loading = true;
      try {
        const { data: res } = await this.$http.get("/university/list", {
          params: {
            pageNum: this.pageNum, // 正确传递当前页
            pageSize: this.pageSize, // 正确传递每页条数
            ...this.searchForm, // 拼接查询条件
          },
        });
        if (res.code === 200) {
          this.tableData = res.data.rows; // 后端返回的当前页数据
          this.total = res.data.total; // 后端返回的总条数
        } else {
          this.$message.error(res.msg || "获取学校列表失败");
        }
      } catch (err) {
        this.$message.error("请求异常：" + err.message);
      } finally {
        this.loading = false;
      }
    },

    /**
     * 点击查询按钮
     */
    handleSearch() {
      this.pageNum = 1; // 重置为第一页
      this.loadUniversityList();
    },

    /**
     * 重置查询条件
     */
    resetSearch() {
      this.searchForm = {
        univName: "",
        provName: "",
        univLocation: "",
        univTypeName: "",
        is985: null,
        is211: null,
        isFirstClass: null,
      };
      this.pageNum = 1; // 重置为第一页
      this.loadUniversityList();
    },

    /**
     * 同步数据到Redis
     */
    async syncToRedis() {
      this.$confirm("确定要同步学校数据到Redis吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(async () => {
          this.btnLoading = true;
          try {
            const { data: res } = await this.$http.post("/university/sync");
            if (res.code === 200) {
              this.$message.success("同步成功");
            } else {
              this.$message.error(res.msg || "同步失败");
            }
          } catch (err) {
            this.$message.error("同步异常：" + err.message);
          } finally {
            this.btnLoading = false;
          }
        })
        .catch(() => {
          this.$message.info("已取消同步");
        });
    },

    /**
     * 导出Excel
     */
    exportExcel() {
      axios
        .request({
          url: "/university/excel",
          method: "post",
          responseType: "blob",
        })
        .then((res) => {
          if (res.headers["content-type"] === "application/json") {
            return res.data.text().then((text) => {
              const json = JSON.parse(text);
              this.$message.error(json.msg || "导出失败");
            });
          }
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "学校列表.xlsx";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          this.$message.success("导出成功");
        })
        .catch((err) => {
          this.$message.error("导出异常：" + err.message);
        });
    },

    /**
     * 打开新增弹窗
     */
    openAddDialog() {
      this.addDialogVisible = true;
      this.resetAddForm();
      // 确保数组的响应性
      this.$nextTick(() => {
        if (!this.addForm.levelFlags) {
          this.$set(this.addForm, "levelFlags", []);
        }
        if (!this.addForm.educationTypes) {
          this.$set(this.addForm, "educationTypes", []);
        }
      });
    },

    /**
     * 打开编辑弹窗
     */
    async openEditDialog(row) {
      this.editDialogVisible = true;
      this.resetEditForm();
      try {
        const { data: res } = await this.$http.get(
          `/university/edit/${row.univId}`
        );
        if (res.code === 200) {
          this.editForm = { ...res.data };

          // 使用 $set 确保响应性
          this.$set(this.editForm, "levelFlags", []);
          this.$set(this.editForm, "educationTypes", []);

          // 复选框回显
          if (this.editForm.is985) this.editForm.levelFlags.push("is985");
          if (this.editForm.is211) this.editForm.levelFlags.push("is211");
          if (this.editForm.isFirstClass)
            this.editForm.levelFlags.push("isFirstClass");
          if (this.editForm.isFirstLevel)
            this.editForm.levelFlags.push("isFirstLevel");

          if (this.editForm.hasRegular)
            this.editForm.educationTypes.push("hasRegular");
          if (this.editForm.hasJunior)
            this.editForm.educationTypes.push("hasJunior");
          if (this.editForm.hasMaster)
            this.editForm.educationTypes.push("hasMaster");
        } else {
          this.$message.error(res.msg || "获取详情失败");
        }
      } catch (err) {
        this.$message.error("请求异常：" + err.message);
      }
    },

    /**
     * 提交新增表单
     */
    submitAddForm() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (valid) {
          // 处理复选框值
          this.addForm.is985 = this.addForm.levelFlags.includes("is985");
          this.addForm.is211 = this.addForm.levelFlags.includes("is211");
          this.addForm.isFirstClass =
            this.addForm.levelFlags.includes("isFirstClass");
          this.addForm.isFirstLevel =
            this.addForm.levelFlags.includes("isFirstLevel");
          this.addForm.hasRegular =
            this.addForm.educationTypes.includes("hasRegular");
          this.addForm.hasJunior =
            this.addForm.educationTypes.includes("hasJunior");
          this.addForm.hasMaster =
            this.addForm.educationTypes.includes("hasMaster");

          this.btnLoading = true;
          try {
            const { data: res } = await this.$http.post(
              "/university/add",
              this.addForm
            );
            if (res.code === 200) {
              this.$message.success("新增成功");
              this.addDialogVisible = false;
              this.loadUniversityList(); // 刷新列表
            } else {
              this.$message.error(res.msg || "新增失败");
            }
          } catch (err) {
            this.$message.error("新增异常：" + err.message);
          } finally {
            this.btnLoading = false;
          }
        }
      });
    },

    /**
     * 提交编辑表单
     */
    submitEditForm() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (valid) {
          // 处理复选框值
          this.editForm.is985 = this.editForm.levelFlags.includes("is985");
          this.editForm.is211 = this.editForm.levelFlags.includes("is211");
          this.editForm.isFirstClass =
            this.editForm.levelFlags.includes("isFirstClass");
          this.editForm.isFirstLevel =
            this.editForm.levelFlags.includes("isFirstLevel");
          this.editForm.hasRegular =
            this.editForm.educationTypes.includes("hasRegular");
          this.editForm.hasJunior =
            this.editForm.educationTypes.includes("hasJunior");
          this.editForm.hasMaster =
            this.editForm.educationTypes.includes("hasMaster");

          this.btnLoading = true;
          try {
            const { data: res } = await this.$http.put(
              `/university/update/${this.editForm.univId}`,
              this.editForm
            );
            if (res.code === 200) {
              this.$message.success("更新成功");
              this.editDialogVisible = false;
              this.loadUniversityList(); // 刷新列表
            } else {
              this.$message.error(res.msg || "更新失败");
            }
          } catch (err) {
            this.$message.error("更新异常：" + err.message);
          } finally {
            this.btnLoading = false;
          }
        }
      });
    },

    /**
     * 删除学校
     */
    handleDelete(id) {
      this.$confirm(`确定删除ID为${id}的学校吗？`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const { data: res } = await this.$http.delete(
              `/university/delete/${id}`
            );
            if (res.code === 200) {
              this.$message.success("删除成功");
              this.loadUniversityList(); // 刷新列表
            } else {
              this.$message.error(res.msg || "删除失败");
            }
          } catch (err) {
            this.$message.error("删除异常：" + err.message);
          }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    /**
     * 重置新增表单
     */
    resetAddForm() {
      if (this.$refs.addFormRef) this.$refs.addFormRef.resetFields();
      this.addForm = {
        univName: "",
        competentDepart: "",
        univAddress: "",
        provName: "",
        univLocation: "",
        univTypeName: "",
        levelFlags: [],
        educationTypes: [],
        logoCloud: "",
        is985: false,
        is211: false,
        isFirstClass: false,
        isFirstLevel: false,
        hasRegular: false,
        hasJunior: false,
        hasMaster: false,
      };
    },

    /**
     * 重置编辑表单
     */
    resetEditForm() {
      if (this.$refs.editFormRef) this.$refs.editFormRef.resetFields();
      this.editForm = {
        univId: "",
        univName: "",
        competentDepart: "",
        univAddress: "",
        provName: "",
        univLocation: "",
        univTypeName: "",
        levelFlags: [],
        educationTypes: [],
        logoCloud: "",
        is985: false,
        is211: false,
        isFirstClass: false,
        isFirstLevel: false,
        hasRegular: false,
        hasJunior: false,
        hasMaster: false,
      };
    },

    /**
     * 分页大小改变
     */
    handleSizeChange(val) {
      this.pageSize = val; // 更新每页条数
      this.pageNum = 1; // 重置为第一页
      this.loadUniversityList(); // 重新加载
    },

    /**
     * 当前页改变
     */
    handleCurrentChange(val) {
      this.pageNum = val; // 更新当前页（核心修复：将原currentPage改为pageNum）
      this.loadUniversityList(); // 重新加载
    },
  },
};
</script>

<style scoped>
.box-card {
  margin: 10px;
}
::v-deep .el-checkbox {
  margin-right: 15px;
}
.search-form {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
::v-deep .el-form-item {
  margin-right: 15px;
}
.el-pagination {
  margin-top: 10px;
}
</style>
